var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIllustrationGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 90,
    viewBox: "0 0 134 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6456 0.779472C17.7279 0.360921 18.0948 0.059082 18.5214 0.059082L122.016 0.059082C122.578 0.059082 123 0.572233 122.892 1.12367L105.616 89.0337C105.533 89.4523 105.167 89.7541 104.74 89.7541H1.60077C0.854782 89.7541 0.294446 89.0729 0.438295 88.3409L17.6456 0.779472Z",
    fill: "#C4C8EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7475 0.905819C17.7793 0.413942 18.1872 0.0593262 18.6801 0.0593262L122.088 0.0593262C122.626 0.0593262 123.041 0.530926 122.974 1.06414L111.821 88.9742C111.764 89.4201 111.45 89.7543 111.001 89.7543C102.619 89.7543 23.6964 89.7543 5.50849 89.7543C4.08378 89.7543 3.18017 88.2107 3.71962 86.892C11.3817 68.1626 17.2119 9.17517 17.7475 0.905819Z",
    fill: "#F0F2FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7817 0.829493C17.8215 0.36823 18.2037 0.0593262 18.6667 0.0593262L122.156 0.0593262C122.669 0.0593262 123.076 0.490684 123.047 1.00279L118.017 88.9145C117.99 89.3862 117.666 89.7549 117.194 89.7559C107.64 89.7746 12.9982 89.9582 11.5663 89.8633C10.1404 89.7688 17.0269 9.57008 17.7817 0.829493Z",
    fill: "#C4C8EA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7652 0.891365C17.7778 0.408233 18.1722 0.0593262 18.6555 0.0593262L122.232 0.0593262C122.716 0.0593262 123.111 0.444183 123.125 0.927402L125.53 88.8374C125.544 89.3397 125.19 89.7543 124.688 89.7543C114.87 89.7543 24.9076 89.7543 20.2417 89.7543C15.5858 89.7543 17.5298 9.94038 17.7652 0.891365Z",
    fill: "#9FA4C7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8802 1.04712C17.8306 0.523528 18.2415 0.0593262 18.7674 0.0593262L122.219 0.0593262C122.708 0.0593262 123.106 0.438181 123.114 0.926533C123.253 8.86997 124.576 69.0794 133.018 85.5959C133.305 86.1575 133.003 86.8311 132.378 86.917C115.005 89.3062 43.264 89.7107 34.6908 89.7507C34.1766 89.7531 33.7419 89.4184 33.5834 88.9292C25.0352 62.5355 21.774 42.2134 17.8802 1.04712Z",
    fill: "#F0F2FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8698 1.02788C17.8253 0.506865 18.2362 0.0593262 18.7591 0.0593262L122.236 0.0593262C122.718 0.0593262 123.113 0.441954 123.128 0.923661L123.595 15.7354L19.0681 15.0354L17.8698 1.02788Z",
    fill: "#DEE2FD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M101.361 24.7395H110.357L111.914 33.7357H102.918L101.361 24.7395Z",
    fill: "#C4C8EA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4438 24.7395H94.44L95.9971 33.7357H87.0009L85.4438 24.7395Z",
    fill: "#C4C8EA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5275 24.7397H78.5237L80.0807 33.7359H71.0845L69.5275 24.7397Z",
    fill: "#C4C8EA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M104.128 38.2336H113.124L114.681 47.2298H105.685L104.128 38.2336Z",
    fill: "#C4C8EA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2115 38.2336H97.2077L98.7647 47.2298H89.7685L88.2115 38.2336Z",
    fill: "#C4C8EA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2955 38.2336H81.2917L82.8487 47.2298H73.8526L72.2955 38.2336Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3792 38.2336H65.3753L66.9324 47.2298H57.9362L56.3792 38.2336Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4629 38.2334H49.4591L51.0161 47.2296H42.02L40.4629 38.2334Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M106.55 52.7676H115.547L117.104 61.7638H108.108L106.55 52.7676Z",
    fill: "#C4C8EA"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6341 52.7676H99.6303L101.187 61.7638H92.1912L90.6341 52.7676Z",
    fill: "#C4C8EA"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7181 52.7676H83.7143L85.2714 61.7638H76.2752L74.7181 52.7676Z",
    fill: "#C4C8EA"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8014 52.7676H67.7976L69.3546 61.7638H60.3584L58.8014 52.7676Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M42.885 52.7676H51.8812L53.4382 61.7638H44.442L42.885 52.7676Z",
    fill: "#C4C8EA"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M93.402 67.2991H102.398L103.955 76.2953H94.959L93.402 67.2991Z",
    fill: "#C4C8EA"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4864 67.2991H86.4826L88.0396 76.2953H79.0434L77.4864 67.2991Z",
    fill: "#C4C8EA"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M61.57 67.2991H70.5662L72.1233 76.2953H63.1271L61.57 67.2991Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6531 67.2993H54.6493L56.2064 76.2955H47.2102L45.6531 67.2993Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIllustrationGray);
export default __webpack_public_path__ + "static/media/calendar-illustration-gray.88561581a6aeee3d719ee11bb4abe2b8.svg";
export { ForwardRef as ReactComponent };